import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class StorageService {
  constructor() {
    this.url = MS_API_BACKEND_URL;
  }

  async getStorageData(params) {
    const url = `${this.url}/api/storage/v1/storages`;
    const { data } = await api.get(url, { params });
    return {
      data: {
        results: data.results ? data.results : data,
        total_count:
          data?.totalCount !== undefined ? data.totalCount : data.length
      }
    };
  }

  async getStorageResume(params) {
    const url = `${this.url}/api/storage/v1/storages-resume`;
    const { data } = await api.get(url, { params });
    return {
      data: {
        results: data,
        total_count: data.length
      }
    };
  }

  async getStorageResumeSku(params) {
    const url = `${this.url}/api/storage/v1/storages-resume/sku`;
    const { data } = await api.get(url, { params });
    return {
      data: {
        results: data,
        total_count: data.length
      }
    };
  }

  async sendStorage(storageForm) {
    const url = `${this.url}/api/storage/v1/storages`;
    const response = await api.post(url, storageForm);
    return { data: response.data[0] };
  }

  async getBaseProducts(params) {
    const url = `${this.url}/api/blueberry/v1/warehouse/product-base/`;
    return await api.get(url, { params });
  }

  async registerUpdate(model) {
    const url = `${this.url}/api/storage/v1/storages/${model.id}`;
    return await api.put(url, {
      quantity: model.quantity
    });
  }

  uploadFile() {
    const url = `${this.url}/api/blueberry/v1/warehouse/storage/upload-repos/estoque.xlsx`;
    return { api, url };
  }

  async registerDelete(id) {
    const url = `${this.url}/api/storage/v1/storages/${id}`;
    return await api.delete(url);
  }

  async getReason() {
    const url = `${this.url}/api/storage/v1/storages/reasons`;
    return await api.get(url);
  }

  async getAllLockedStorage(params) {
    const url = `${this.url}/api/storage/v1/storages/lock`;
    const { data } = await api.get(url, { params });
    return {
      data: {
        total_count: data.totalCount,
        ...data
      }
    };
  }

  async lockStorage(data) {
    const url = `${this.url}/api/storage/v1/storages/lock`;
    await api.post(url, data);
  }

  async unlockStorage(data, lockId) {
    const url = `${this.url}/api/storage/v1/storages/unlock/${lockId}`;
    await api.post(url, data);
  }

  async getCancellationApprovals(params) {
    const url = `${this.url}/api/storage/v1/storages/cancellation-approvals`;
    return await api.get(url, { params });
  }

  async reviewCancellation(id, body) {
    const url = `${this.url}/api/storage/v1/storages/cancellation-approvals/${id}/review`;
    const { data } = await api.post(url, body);
    return data;
  }
}

const storageService = new StorageService();
export default storageService;
